export const config = {
    env: "PROD", // OPTIONS: "STAG" ; "PROD" ; "PREPROD"
    LogRocket: false,
    tenantUrl: "https://login.microsoftonline.com/groupevital.com",
    clientId: "c6701e56-6f31-4a76-af87-92dd0c8848a0",
    timezone: "Europe/Paris",
    scopes: {
        collabs: "collabs",
        shifts: "shifts",
        leaves: "leaves",
        ownLeaves: "leaves.own",
        groups: "groups",
        settings: "settings",
        reports: "reports",
        warnings: "warnings",
        evaluations: "evaluations",
        vcomp: "vcomp",
        ventr: "ventr",
        medicalVisits: "medicalVisits",
        news: "news",
        opportunities: "opportunities"
    },
    permissionTypes: {
        view: "view",
        edit: "edit",
        remove: "remove"
    },
    apiPaths: {
        user: {
            login: "/user/login",
            session: "/user/session",
            logout: "/user/logout",
            msAuth: "/ms-auth",
            sendActivationLink: "/user/sendActivationLink",
            setPassword: "/user/setPassword",
        },
        planning: {
            getHolidays: "/v1/planning/getHolidays",
            getTeams: "/v1/planning/getTeams",
            addGroupe: "/v1/planning/addGroupe",
            getGroupes: "/v1/planning/getGroupes",
            updateGroupe: "/v1/planning/updateGroupe",
            deleteGroupes: "/v1/planning/deleteGroupes",
            getCollabs: "/v1/planning/getCollabs",
            getAllCollabs: "/v1/planning/getAllCollabs",
            resetCollabPassword: "/v1/planning/resetCollabPass",
            updateCollabs: "/v1/planning/updateCollabs",
            mergeCollabs: "/v1/planning/mergeCollabs",
            getMembers: "/v1/planning/getMembers",
            addGroupeMembers: "/v1/planning/addGroupeMembers",
            removeGroupeMembers: "/v1/planning/removeGroupeMembers",
            getSettings: "/v1/planning/getSettings",
            updateSettings: "/v1/planning/updateSettings",
            getTeamSettings: "/v1/planning/getTeamSettings",
            updateTeamSettings: "/v1/planning/updateTeamSettings",
            addShiftSample: "/v1/planning/addShiftSample",
            getShiftSamples: "/v1/planning/getShiftSamples",
            deleteShiftSamples: "/v1/planning/deleteShiftSamples",
            updateShiftSample: "/v1/planning/updateShiftSample",
            getPlanning: "/v1/planning/getPlanning",
            addShifts: "/v1/planning/addShifts",
            updateShifts: "/v1/planning/updateShifts",
            deleteShifts: "/v1/planning/deleteShifts",
            prefill: "/v1/planning/prefill",
            delete: "/v1/planning/delete",
            getClients: "/v1/planning/getClients",
            submitShifts: "/v1/planning/submitShifts",
            addLeaveSample: "/v1/planning/addLeaveSample",
            getLeaveSamples: "/v1/planning/getLeaveSamples",
            deleteLeaveSamples: "/v1/planning/deleteLeaveSamples",
            updateLeaveSample: "/v1/planning/updateLeaveSample",
            requestLeave: "/v1/planning/requestLeave",
            submitLeave: "/v1/planning/submitLeave",
            deleteLeave: "/v1/planning/deleteLeave",
            requestDeleteLeave: "/v1/planning/requestDeleteLeave",
            getTimesheets: "/v1/planning/getTimesheets",
            getCollabPlanning: "/v1/planning/getCollabPlanning",
            updateTimesheet: "/v1/planning/updateTimesheet",
            updateCollabsOrder: "/v1/planning/updateCollabsOrder",
            getReports: "/v1/planning/getReports",
            generateReport: "/v1/planning/generateReport",
            getCollabReport: "/v1/planning/getCollabReport",
            generateCraPdf: "/v1/planning/generateCraPdf",
            generateCraZip: "/v1/planning/generateCraZip",
            stopZipGeneration: "/v1/planning/stopZipGeneration",
            zipGenerationProgress: "/v1/planning/zipGenerationProgress",
            insertPrimeCollab: "/v1/planning/insertPrimeCollab",
            getPermissions: "/v1/planning/getPermissions",
            setPermissions: "/v1/planning/setPermissions",
            setTeamPermissions: "/v1/planning/setTeamPermissions",
            getTeamPermissions: "/v1/planning/getTeamPermissions",
            getAllWarnings: "/v1/planning/getWarnings",
            deleteWarning: "/v1/planning/deleteWarning",
            editWarnings: "/v1/planning/editWarnings",
            addWarning: "/v1/planning/addWarning",
            getEvaluations: "/v1/planning/getEvaluations",
            deleteEvaluation: "/v1/planning/deleteEvaluation",
            addEvaluation: "/v1/planning/addEvaluation",
            editEvaluation: "/v1/planning/editEvaluation",
            getEvaluationFields: "/v1/planning/getEvaluationFields",
            getEvaluationsReport: "/v1/planning/getEvaluationsReport",
            getMonthlyEvaluations: "/v1/planning/getMonthlyEvaluations",
            deleteEvaluationField: "/v1/planning/deleteEvaluationField",
            addEvaluationField: "/v1/planning/addEvaluationField",
            getEvaluationsTypes: "/v1/planning/getEvaluationsTypes",
            reorderEvaluationsFields: "/v1/planning/reorderEvaluationsFields",
            reorderEvaluationTypes: "/v1/planning/reorderEvaluationTypes",
            editEvaluationField: "/v1/planning/editEvaluationField",
            addEvaluationsType: "/v1/planning/addEvaluationsType",
            editEvaluationsType: "/v1/planning/editEvaluationsType",
            getCompanies: "/v1/planning/getCompanies",
            getSingleCollabDetails: "/v1/planning/getSingleCollabDetails",
            getPostes: "/v1/planning/getPostes",
            getTeamCollabs: "/v1/planning/getTeamCollabs",
            addEditClient: "/v1/planning/addEditClient",
            generateAnnualPrimeReport: "/v1/planning/generateAnnualPrimeReport",
            getSpecialCases: "/v1/planning/getSpecialCases",
            addSpecialCase: "/v1/planning/addSpecialCase",
            editSpecialCase: "/v1/planning/editSpecialCase",
            getCollabsMissionsWithinTeam: "/v1/planning/getCollabsMissionsWithinTeam",
            getInactiveClients: "/v1/planning/getInactiveClients"
        },
        vcomp: {
            addEditVcompProject: "/v1/vcomp/addEditVcompProject",
            deleteProject: "/v1/vcomp/deleteProject",
            getBankAptitudesOnCreation: "/v1/vcomp/getBankAptitudesOnCreation",
            addDefaultProjectForm: "/v1/vcomp/addDefaultProjectForm",
            reorderProjectForm: "/v1/vcomp/reorderProjectForm",
            getProjects: "/v1/vcomp/getProjects",
            addEditCategory: "/v1/vcomp/addEditCategory",
            addEditAptitude: "/v1/vcomp/addEditAptitude",
            getProjectAptitudes: "/v1/vcomp/getProjectAptitudes",
            deleteProjectCatSub: "/v1/vcomp/deleteProjectCatSub",
            deleteProjectAptitude: "/v1/vcomp/deleteProjectAptitude",
            getProjectMembersAndManagers: "/v1/vcomp/getProjectMembersAndManagers",
            getCollabsNames: "/v1/vcomp/getCollabsNames",
            addRemoveProjectCollabsManagers: "/v1/vcomp/addRemoveProjectCollabsManagers",
            reorderPublicForm: "/v1/vcomp/reorderPublicForm",
            hidePublicCatSub: "/v1/vcomp/hidePublicCatSub",
            hidePublicAptitudes: "/v1/vcomp/hidePublicAptitudes",
            getAptitudeQuestions: "/v1/vcomp/getAptitudeQuestions",
            getProjectAptitudesWithValues: "/v1/vcomp/getProjectAptitudesWithValues",
            answerAptitudeDailyBase: "/v1/vcomp/answerAptitudeDailyBase",
            getProjectProgress: "/v1/vcomp/getProjectProgress",
            editResponseManager: "/v1/vcomp/editResponseManager",
            activateMcqCollabs: "/v1/vcomp/activateMcqCollabs",
            addEditQuestion: "/v1/vcomp/addEditQuestion",
            addEditQuestionAnswers: "/v1/vcomp/addEditQuestionAnswers",
            deleteQuestion: "/v1/vcomp/deleteQuestion",
            deleteQuestionAnswer: "/v1/vcomp/deleteQuestionAnswer",
            aptitudeMcqVisibility: "/v1/vcomp/aptitudeMcqVisibility",
            getProjectQuestions: "/v1/vcomp/getProjectQuestions",
            recordMcqResponsePerProject: "/v1/vcomp/recordMcqResponsePerProject",
            getCollabMcqResults: "/v1/vcomp/getCollabMcqResults",
            importProjectFromExcel: "/v1/vcomp/importProjectFromExcel",
            getCollabResponseHistory: "/v1/vcomp/getCollabResponseHistory",
            getProjectQuestionsBank: "/v1/vcomp/getProjectQuestionsBank",
            deleteVcompProjectsWithConnections: "/v1/vcomp/deleteVcompProjectsWithConnections",
            updateNeededCollabsPerSession: "/v1/vcomp/updateNeededCollabsPerSession"
        },
        ventr: {
            getInterviews: "/v1/entretiens/getInterviews",
            insertInterview: "/v1/entretiens/insertInterview",
            updateInterview: "/v1/entretiens/updateInterview",
            generateInterviewPDF: "/v1/entretiens/generateInterviewPDF"
        },
        teams: {
            addRemoveMembers: "/v1/teams/addRemoveMembers",
            getTeamsManagers: "/v1/teams/getTeamsManagers",
            getAllTeamsManagers: "/v1/teams/getAllTeamsManagers",
            addTeamManager: "/v1/teams/addTeamManager",
            editTeam: "/v1/teams/editTeam",
            addTeam: "/v1/teams/addTeam",
            removeTeamManager: "/v1/teams/removeTeamManager",
            getPostesSettings: "/v1/teams/getPostesSettings",
            addEditPoste: "/v1/teams/addEditPoste",
            removePoste: "/v1/teams/removePoste",
            getOpportunities: "/v1/teams/getOpportunities",
            addOpportunity: "/v1/teams/addOpportunity",
            getCollabMissions: "/v1/teams/getCollabMissions",
            getAllMissions: "/v1/teams/getAllMissions",
            editCollabMission: "/v1/teams/editCollabMission",
            addCollabMission: "/v1/teams/addCollabMission",
            deleteCollabMission: "/v1/teams/deleteCollabMission",
            getManagersPermissions: "/v1/teams/getManagersPermissions",
            updateManagersPermissions: "/v1/teams/updateManagersPermissions",
            editCollabProfile: "/v1/teams/editCollabProfile",
            editOpportunity: "/v1/teams/editOpportunity",
            getEndingContracts: "/v1/teams/getEndingContracts",
            changeTeamActiveStatus: "/v1/teams/changeTeamActiveStatus",
            getInActiveTeams: "/v1/teams/getInActiveTeams"
        },
        subcontractors: {
            getSubcontractors: "/v1/subcontractors/getSubcontractors",
            addSubcontractor: "/v1/subcontractors/addSubcontractor",
            editSubcontractor: "/v1/subcontractors/editSubcontractor",
            getSubcontractorCollabs: "/v1/subcontractors/getSubcontractorCollabs",
            addCollabsToSubcontractor: "/v1/subcontractors/addCollabsToSubcontractor",
            removeCollabsFromSubcontractor: "/v1/subcontractors/removeCollabsFromSubcontractor",
            getSkillsSettings: "/v1/subcontractors/getSkillsSettings",
            addEditSkill: "/v1/subcontractors/addEditSkill",
            removeSkill: "/v1/subcontractors/removeSkill"
        },
        assets: {
            getCollabAssets: "/v1/assets/getCollabAssets",
            getSubcontractorAssets: "/v1/assets/getSubcontractorAssets",
            uploadAsset: "/v1/assets/uploadAsset",
            downloadAsset: "/v1/assets/download",
            deleteAsset: "/v1/assets/delete",
        },
        collabs: {
            addCollab: "/v1/collabs/addCollab",
            editCollab: "/v1/collabs/editCollab",
            addCollabContract: "/v1/collabs/addCollabContract",
            editCollabContract: "/v1/collabs/editCollabContract",
            getCollabContract: "/v1/collabs/getCollabContract",
            deleteCollabContract: "/v1/collabs/deleteCollabContract",
            getAllContracts: "/v1/collabs/getAllContracts",
            updateWeeklyReview: "/v1/collabs/updateWeeklyReview",
            getAllWeeklyReviews: "/v1/collabs/getAllWeeklyReviews"
        },
        medicalVisits: {
            getAll: "/v1/medicalVisits/getAll",
            update: "/v1/medicalVisits/update"
        },
        dashboard: {
            getCollabData: "/v1/dashboard/getCollabData",
            addNews: "/v1/dashboard/addNews",
            getVcompNotifications: "/v1/dashboard/getVcompNotifications",
            markNewsAsRead: "/v1/dashboard/markNewsAsRead",
            deleteNews: "/v1/dashboard/deleteNews",
            getNewsViewers: "/v1/dashboard/getNewsViewers"
        },
        employmentPromises: {
            getAll: "/v1/employmentPromises/getAll",
            insert: "/v1/employmentPromises/insert",
            update: "/v1/employmentPromises/update",
            delete: "/v1/employmentPromises/delete"
        }
    }
}